import { MAX_CART_SIZE } from '../../../core/constants/store';
import { TICKET_PRICE } from '../../../core/constants/lottery';
import { formatCurrency, formatTime } from '../../../core/utils/format';
import { useCart } from '../contexts/cart';

import '../styles/cart.css';

// Subcomponent surface of the store layout: the running selection.

export default function StoreCart({ playsAt, onCheckout }) {
    const { selected, count, total, remove, clear } = useCart();
    const isEmpty = count === 0;

    return (
        <aside className={`store-cart panel ${isEmpty ? 'store-cart--empty' : ''}`}>
            <header className="store-cart__head">
                <h2 className="store-cart__title">Tu compra</h2>
                <span className="store-cart__counter">{count}/{MAX_CART_SIZE}</span>
            </header>

            {isEmpty ? (
                <p className="store-cart__empty">
                    Todavía no has elegido ningún número. Toca cualquier casilla disponible
                    o usa “Número sorpresa”.
                </p>
            ) : (
                <ul className="store-cart__list">
                    {selected.map(number => (
                        <li className="store-cart__item" key={number}>
                            <span className="store-cart__number">{number}</span>
                            <span className="store-cart__price">{formatCurrency(TICKET_PRICE)}</span>
                            <button
                                type="button"
                                className="store-cart__remove"
                                onClick={() => remove(number)}
                                aria-label={`Quitar el número ${number}`}
                            >
                                ✕
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            <footer className="store-cart__foot">
                <div className="store-cart__total">
                    <span className="store-cart__total-label">Total</span>
                    <strong className="store-cart__total-value">{formatCurrency(total)}</strong>
                </div>

                <button
                    type="button"
                    className="button button--primary store-cart__pay"
                    disabled={isEmpty}
                    onClick={onCheckout}
                >
                    Pagar {count > 0 && `${count} ${count === 1 ? 'número' : 'números'}`}
                </button>

                <p className="store-cart__note">
                    Juegan en el sorteo de las {formatTime(playsAt)}.
                </p>

                {!isEmpty && (
                    <button type="button" className="store-cart__clear" onClick={clear}>
                        Vaciar selección
                    </button>
                )}
            </footer>
        </aside>
    );
}
